import { render, staticRenderFns } from "./AscFeeSchedules.vue?vue&type=template&id=abb2a53c"
import script from "./AscFeeSchedules.vue?vue&type=script&lang=js"
export * from "./AscFeeSchedules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports